var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 7.5,
    stroke: "#482714"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7062 13.5556V19M11.7062 19L9.41211 16.6667M11.7062 19L14.0003 16.6667M11.7062 5V10.4444M11.7062 5L9.41211 7.33333M11.7062 5L14.0003 7.33333",
    stroke: "#CD8F6C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeightIcon);
export default __webpack_public_path__ + "static/media/heightIcon.3b48b0889aa1c2c29605234d5d927a22.svg";
export { ForwardRef as ReactComponent };